/**
 * The Front and Back end devs need to share certain values that impact the
 * business logic of the application.  From the point of view of the Front End,
 * this file is the single source of truth for this information.
 */

export const MATHLETICS_PRODUCT_ID = '1';
export const PHONICS_PRODUCT_ID = '8';



// WEBPACK FOOTER //
// ./helpers/backend-constants-contract.js